import { render, staticRenderFns } from "./BrokerDashboard.vue?vue&type=template&id=5753c09a&scoped=true"
import script from "./BrokerDashboard.vue?vue&type=script&lang=js"
export * from "./BrokerDashboard.vue?vue&type=script&lang=js"
import style0 from "./BrokerDashboard.vue?vue&type=style&index=0&id=5753c09a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753c09a",
  null
  
)

export default component.exports